import { LitElement } from 'lit';
import { html } from 'lit';
import { query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FormGroup } from '../../../../../../../ui/gzForm/formGroup/form-group';
import { Subscription } from 'rxjs';
import { GzButtonWebComponent } from '../../../../../../../ui/gzButton';
import { OnNewGridItemAdd } from '../../events/events';
import { TemplateResult } from 'lit/development';
import { TextHighlightMixin } from '../../../../../../../mixins';
import { connect } from 'pwa-helpers';
import { RootState, store } from '@nirvana/redux/store';
import { selectAccordionsSearchState } from '@nirvana/redux/searchable-ui-accordions';

export abstract class GzPolicyUiSettingsGridItemFormWebComponent extends TextHighlightMixin(
  connect(store)(LitElement)
) {
  // form group
  public formGroup: FormGroup;
  // subscription
  private subscription: Subscription;
  // searchable keywords
  protected searchableKeywords;

  // selectors
  @query('#addButton')
  addButton: GzButtonWebComponent;

  /**
   * Styles for the component.
   */
  static get styles() {
    return styles;
  }

  /**
   * State changed, update search string.
   * @param rootState
   */
  public stateChanged(rootState: RootState) {
    const accordionsSearchApp = selectAccordionsSearchState(rootState);
    this.searchString = accordionsSearchApp.searchString;
  }

  /**
   * Set the error for component.
   * @param error
   */
  public setError(error: string) {}

  /**
   * Focus first input. Used by gz-data-table.
   */
  public focusFirstInput() {}

  /**
   * Create form group and subscribe to valid.
   * @param changedProperties
   */
  protected firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this.createFormGroup();
    this.subscribeToValid();
  }

  /**
   * Render specific content.
   */
  protected render() {
    return html`
      <div class="policy-grid-item-form">
        <div class="policy-grid-item-form--row d-flex flex-row align-items-center">
          ${this.renderFormFields()}

          <div class="policy-grid-item-form--actions">
            <gz-icon-button
              id="addButton"
              size="32"
              fontSize="20"
              buttonType="square"
              icon="ds-icon-add"
              buttonFill="primary"
              @click="${this.addNewItem}"
            >
            </gz-icon-button>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Unsubscribe from form group.
   */
  disconnectedCallback(): void {
    this.formGroup?.unsubscribe();
    this.subscription?.unsubscribe();
    super.disconnectedCallback();
  }

  /**
   * Subscribe to valid.
   */
  private subscribeToValid() {
    this.subscription = this.formGroup.valid$.subscribe({
      next: valid => {
        this.addButton.disabled = !valid;
      },
    });
  }

  /**
   * Dispatch event for new grid item add.
   */
  protected addNewItem() {
    this.dispatchEvent(new OnNewGridItemAdd(this.formGroup.value));
  }

  /**
   * Implemented in child components to create form group.
   */
  protected abstract createFormGroup(): void;
  /**
   * Implemented in child components to render form fields.
   */
  protected abstract renderFormFields(): TemplateResult;
  /**
   * Implemented in child components to reset form.
   */
  public abstract reset(): void;
  /**
   * Implemented in child components to reset form on add.
   */
  public abstract resetOnAdd(): void;
}
